import type { FaqGroup } from '../lib/types';
import { FaqItem } from './FaqItem';

export interface FaqListProps {
  /** Ordered. First entry is the active context and carries the navy eyebrow. */
  groups: FaqGroup[];
  selectedId?: string | null;
  onSelect: (faqId: string) => void;
  /** Count hidden behind "Show more"; 0 hides the link. */
  remaining?: number;
  onShowMore?: () => void;
}

/** The left pane: flat rows under small-caps eyebrows, navy for the active group and muted after. */
export function FaqList({ groups, selectedId = null, onSelect, remaining = 0, onShowMore }: FaqListProps) {
  const [active, ...rest] = groups;

  return (
    <div className="flex min-h-0 flex-col bg-white xl:h-full">
      <span className="shrink-0 px-[18px] pb-2 pt-4 text-[10px] font-bold uppercase tracking-[0.09em] text-dvaNavy">
        {active.label}
      </span>

      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
        {active.faqs.map((faq) => (
          <FaqItem key={faq.id} question={faq.question} selected={faq.id === selectedId} onClick={() => onSelect(faq.id)} />
        ))}

        {rest.map((group) => (
          <div key={group.key} className="contents">
            <span className="shrink-0 px-[18px] pb-2 pt-[18px] text-[10px] font-bold uppercase tracking-[0.09em] text-[#717182]">
              {group.label}
            </span>
            {group.faqs.map((faq) => (
              <FaqItem key={faq.id} question={faq.question} selected={faq.id === selectedId} onClick={() => onSelect(faq.id)} />
            ))}
          </div>
        ))}

        {remaining > 0 && (
          <button
            type="button"
            onClick={onShowMore}
            className="ml-[18px] mt-3 self-start border-b border-[#e5e7eb] pb-px text-[12.5px] font-semibold text-dvaNavy hover:border-dvaNavy focus-visible:rounded focus-visible:ring-[3px] focus-visible:ring-dvaOrange/35 focus-visible:outline-none"
          >
            {`Show ${remaining} more`}
          </button>
        )}
      </div>
    </div>
  );
}
